import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Company, SeminarIcon, ProductIcon, AdvertisementIcon, LiveStreamIcon, SettingSellProduct,
} from '../Icons/Icon';
import DetailCompany from '../../containers/admin/CompanyManagement/DetailCompany';
import ListSeminar from '../../containers/admin/CompanyManagement/ListSeminar';
import ListProductExhibition from '../../containers/admin/CompanyManagement/ListProductExhibition';
import AdvertisementManagement from '../../containers/admin/AdvertisementManagement/AdvertisementManagement';
import ListLiveStream from '../../containers/admin/CompanyManagement/ListLiveStream';
import SettingProductCompany from '../../containers/admin/SettingProductCompany/SettingProductCompany';

const CompanyMangementSystem = [
    {
        path: '/company-detail',
        param: '/:shortName/:idCompany',
        name: <FormattedMessage id="adminSidebar.companyManagement" />,
        icon: Company,
        component: DetailCompany,
        layout: '/admin',
    },
    {
        path: '/list-product-exhibition',
        param: '/:shortName/:idCompany',
        name: <FormattedMessage id="adminSidebar.productExhibitionManagement" />,
        icon: ProductIcon,
        component: ListProductExhibition,
        layout: '/admin',
    },
    {
        path: '/setting-product-company',
        param: '/:shortName/:idCompany',
        name: <FormattedMessage id="adminSidebar.settingProductCompany" />,
        icon: SettingSellProduct,
        component: SettingProductCompany,
        layout: '/admin',
    },
    {
        path: '/seminar-management',
        param: '/:shortName/:idCompany',
        name: <FormattedMessage id="adminSidebar.seminarManagement" />,
        icon: SeminarIcon,
        component: ListSeminar,
        layout: '/admin',
    },
    {
        path: '/live-stream-management',
        param: '/:shortName/:idCompany',
        name: <FormattedMessage id="adminSidebar.liveStreamManagement" />,
        icon: LiveStreamIcon,
        component: ListLiveStream,
        layout: '/admin',
    },
    {
        path: '/advertisement-management',
        param: '/:shortName/:idCompany',
        name: <FormattedMessage id="adminSidebar.advertisementManagement" />,
        icon: AdvertisementIcon,
        component: AdvertisementManagement,
        layout: '/admin',
    },
];

export default CompanyMangementSystem;
